// extracted by mini-css-extract-plugin
module.exports = {"Difficulty":"Difficulty_Difficulty__Cd7e1","Difficulty__Button":"Difficulty_Difficulty__Button__2KkTm"};